const createAssetSourcesApi = ({ assetSources }) => ({
    assetSources: {
        getSupportedPurposes: assetSources.getSupportedPurposes,
        getDefaultPurpose: assetSources.getDefaultPurpose,
        isSupported: assetSources.isSupported,
    },
});
const assetSourcesApiDefinition = {
    id: 'assetSourcesApi',
    type: 'api',
    factory: createAssetSourcesApi,
    dependencies: ['assetSources'],
};
export default assetSourcesApiDefinition;
